import React, { useEffect, useRef, useState } from "react";
import {
    LoadingDiv,
    SweetAlertShow,
} from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";

import {
    esslEmployeesList,
    esslDeviceList
} from "../../../api/EsslDevice";
import axios from "axios";

export default function EsslRegisteredUsers() {

    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({});
    const [data, setData] = useState([]);

    // jis row pe api chal rahi hai
    const [processingId, setProcessingId] = useState(null);
    const [devices, setDevices] = useState([]);

    // background refresh
    const pollingRef = useRef(null);


    const getDevices = async () => {

        try {

            const response = await esslDeviceList();

            if (response?.data?.status) {

                setDevices(response?.data?.data || []);

            }

        } catch (error) {

            console.log(error);

        }

    };

    const getRegisteredUsers = async (showLoader = true) => {

        try {

            if (showLoader) {
                setLoading(true);
            }

            let addUrl = "";

            Object.keys(filters).forEach((key) => {

                if (filters[key]) {

                    addUrl += `&${key}=${encodeURIComponent(filters[key])}`;

                }

            });

            const response = await esslEmployeesList(addUrl);

            if (response?.data?.status) {

                const list =
                    response?.data?.data?.employees ??
                    response?.data?.data ??
                    [];

                setData(list);

                const hasPending = list.some(
                    (item) =>
                        item?.Status?.toLowerCase() === "pending"
                );

                if (hasPending) {

                    if (!pollingRef.current) {

                        pollingRef.current = setInterval(() => {

                            getRegisteredUsers(false);

                        }, 30000);

                    }

                } else {

                    if (pollingRef.current) {

                        clearInterval(pollingRef.current);

                        pollingRef.current = null;

                    }

                    setProcessingId(null);

                }




            }

        } catch (error) {

            console.log(error);

            if (showLoader) {

                SweetAlertShow(
                    "error",
                    "Error",
                    error?.response?.data?.message ??
                    error?.message
                );

            }

        } finally {

            if (showLoader) {

                setLoading(false);

            }

        }

    };

    const handleBlockUnBlock = async (item, isBlock) => {

        try {

            const employeeDevices = item?.devices || [];

            if (!employeeDevices.length) {

                SweetAlertShow(
                    "warning",
                    "Warning",
                    "Employee ke liye koi device nahi mila."
                );

                return;
            }

            const allDevicesOnline = employeeDevices.every(empDevice => {

                const device = devices.find(
                    d => d.serial_number === empDevice.serial_number
                );

                return (
                    device?.device_status?.data?.DeviceStatus === "Online"
                );
            });

            if (!allDevicesOnline) {

                SweetAlertShow(
                    "warning",
                    "Device Offline",
                    "Employee ki sabhi machines online nahi hain."
                );

                return;
            }

            setProcessingId(item.EmployeeId);

            const requests = employeeDevices.map(device =>
                axios.post(
                    "http://192.168.1.243:5003/blockUnblockUser",
                    {
                        EmployeeCode: item.EmployeeCode,
                        EmployeeName: item.EmployeeName,
                        SerialNumber: device.serial_number,
                        IsBlock: isBlock
                    }
                )
            );

            const responses = await Promise.all(requests);

            const allSuccess = responses.every(
                res => res?.data?.status
            );

            if (allSuccess) {

                SweetAlertShow(
                    "success",
                    "Success",
                    `Block/Unblock request submitted successfully for ${employeeDevices.length} device(s).`
                );

                getRegisteredUsers(false);

            } else {

                setProcessingId(null);

                SweetAlertShow(
                    "error",
                    "Error",
                    "The request could not be completed on one or more devices."
                );
            }

        } catch (error) {

            setProcessingId(null);

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message || error.message
            );
        }
    };


    useEffect(() => {
        getDevices();
    }, []);

    useEffect(() => {

        getRegisteredUsers();

        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
            }
        };

    }, [filters]);

    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">
                                <div className="row">
                                    <Master />
                                    <div className="col-12">
                                        <div className="card mb-4">
                                            <div className="card-body">
                                                <div className="row g-3 align-items-end">
                                                    <div className="col-md-4">
                                                        <h4 className="mb-0">Registered ESSL Users</h4>
                                                    </div>

                                                    <div className="col-12">
                                                        <hr />
                                                    </div>

                                                    {/* Search */}
                                                    <div className="col-md-4">
                                                        <div className="form-floating form-floating-outline">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search..."
                                                                value={filters?.search || ""}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        search: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                            <label>Search</label>
                                                        </div>
                                                    </div>


                                                    {/* User Type */}
                                                    <div className="col-md-3">
                                                        <div className="form-floating form-floating-outline">
                                                            <select
                                                                className="form-select"
                                                                value={filters?.type || ""}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        type: e.target.value,
                                                                    })
                                                                }
                                                            >
                                                                <option value="">All Users</option>
                                                                <option value="Student">Student</option>
                                                                <option value="Staff">Staff</option>
                                                            </select>
                                                            <label>User Type</label>
                                                        </div>
                                                    </div>

                                                    {/* Clear Button */}
                                                    <div className="col-md-1">
                                                        <button
                                                            className="btn btn-outline-danger w-100"
                                                            onClick={() => setFilters({})}
                                                        >
                                                            <i className="ri-refresh-line"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card mb-4">
                                            <div className="card-body">

                                                <div className="table-responsive">

                                                    <table className="table table-hover align-middle">

                                                        <thead>

                                                            <tr>

                                                                <th>#</th>

                                                                <th>Type / Registration No</th>

                                                                <th>Name</th>

                                                                <th>Father Name</th>

                                                                <th>Employee</th>

                                                                <th>Devices</th>

                                                                <th>Status</th>

                                                                <th>Action</th>

                                                            </tr>

                                                        </thead>

                                                        <tbody>

                                                            {data?.length > 0 ?

                                                                data.map((item, index) => (

                                                                    <tr key={item.EmployeeId}>

                                                                        <td>

                                                                            {index + 1}

                                                                        </td>

                                                                        <td>

                                                                            {item.user_type}

                                                                            <br />

                                                                            <small>

                                                                                {item?.user_data?.registration_no}

                                                                            </small>

                                                                        </td>

                                                                        <td>

                                                                            {item?.user_data?.name}

                                                                        </td>

                                                                        <td>

                                                                            {item?.user_data?.father_name}

                                                                        </td>

                                                                        <td>

                                                                            <div>

                                                                                <b>ID :</b> {item.EmployeeId}

                                                                            </div>

                                                                            <div>

                                                                                <b>Code :</b> {item.EmployeeCode}

                                                                            </div>

                                                                        </td>

                                                                        <td>

                                                                            {

                                                                                item.devices?.length ?

                                                                                    item.devices.map(device => (

                                                                                        <div
                                                                                            key={device.device_id}
                                                                                            className="mb-2"
                                                                                        >

                                                                                            <div>

                                                                                                <b>

                                                                                                    {device.device_id}

                                                                                                </b>

                                                                                            </div>

                                                                                            <small>

                                                                                                {device.serial_number}

                                                                                            </small>

                                                                                        </div>

                                                                                    ))

                                                                                    :

                                                                                    "-"

                                                                            }

                                                                        </td>

                                                                        {/* STATUS */}

                                                                        <td>

                                                                            {processingId === item.EmployeeId ||
                                                                                item?.Status?.toLowerCase() === "pending" ? (

                                                                                <div className="d-flex align-items-center">

                                                                                    <div
                                                                                        className="spinner-border spinner-border-sm text-warning me-2"
                                                                                        role="status"
                                                                                    />

                                                                                    <span>Pending...</span>

                                                                                </div>

                                                                            ) : item?.Status?.toLowerCase() === "success" ? (

                                                                                item?.Type === "Block User" ? (

                                                                                    <span className="badge bg-danger">
                                                                                        Blocked
                                                                                    </span>

                                                                                ) : item?.Type === "Un Block User" ? (

                                                                                    <span className="badge bg-success">
                                                                                        Unblocked
                                                                                    </span>

                                                                                ) : (

                                                                                    <span className="badge bg-primary">
                                                                                        Success
                                                                                    </span>

                                                                                )

                                                                            ) : item?.Status ? (

                                                                                <span className="badge bg-warning text-dark">

                                                                                    {item.Status}

                                                                                </span>

                                                                            ) : (

                                                                                <span className="badge bg-secondary">
                                                                                    No Action
                                                                                </span>

                                                                            )}

                                                                        </td>

                                                                        {/* ACTION */}

                                                                        <td>

                                                                            {processingId === item.EmployeeId ||
                                                                                item?.Status?.toLowerCase() === "pending" ? (

                                                                                <button
                                                                                    className="btn btn-secondary btn-sm"
                                                                                    disabled
                                                                                >

                                                                                    <span
                                                                                        className="spinner-border spinner-border-sm me-2"
                                                                                    />

                                                                                    Processing...

                                                                                </button>

                                                                            ) : (

                                                                                <div className="btn-group">

                                                                                    <button
                                                                                        className="btn btn-danger btn-sm"
                                                                                        onClick={() =>
                                                                                            handleBlockUnBlock(item, 1)
                                                                                        }
                                                                                    >
                                                                                        Block
                                                                                    </button>

                                                                                    <button
                                                                                        className="btn btn-success btn-sm"
                                                                                        onClick={() =>
                                                                                            handleBlockUnBlock(item, 0)
                                                                                        }
                                                                                    >
                                                                                        Un Block
                                                                                    </button>

                                                                                </div>

                                                                            )}

                                                                        </td>

                                                                    </tr>

                                                                ))

                                                                :

                                                                <tr>

                                                                    <td
                                                                        colSpan="8"
                                                                        className="text-center py-5"
                                                                    >

                                                                        No Data Found

                                                                    </td>

                                                                </tr>

                                                            }

                                                        </tbody>

                                                    </table>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
